import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 'clamp(400px, 40vw + 1em, 700px)',
    overflowX: 'auto',
    cursor: 'grab',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
}))

export default useStyles
